import script from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=724f99d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724f99d6"]])

export default __exports__